export const getCookieInClientSide = (name: string): string | undefined => {
  if (typeof document === "undefined") return undefined;
  return document.cookie
    ?.split("; ")
    .map((c) => c.split("="))
    .reduce<Record<string, string>>((acc, [k, v]) => {
      acc[k] = v;
      return acc;
    }, {})?.[name];
};
